import * as React from 'react'

import { useMutation } from '@apollo/client'
import { Box, Text } from '@factorialco/deprecated-design-system'
import { F0Button } from '@factorialco/f0-react'
import { SendForSignatureItAssetDocumentDocument } from 'generated/resources/graphql'

import Modal from 'modules/core/components/Modal'
import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import i18n from 'modules/core/lib/i18n'
import app from 'modules/core/store/models/app'

import { EmployeeSelectorV2 } from 'modules/employees/components/EmployeeSelectorV2'

interface Props {
  onClose: () => void
}

export const EmployeeTestModal = ({ onClose }: Props) => {
  const [selectedEmployeeId, setSelectedEmployeeId] = React.useState<number | undefined>(undefined)
  const { company } = useCurrentSession()
  const [sendForSignature, { loading }] = useMutation(SendForSignatureItAssetDocumentDocument)

  const handleSubmit = async () => {
    if (!selectedEmployeeId || !company?.id) return

    try {
      await sendForSignature({
        variables: {
          companyId: Number(company.id),
          employeeIds: [selectedEmployeeId],
        },
      })

      app.setFlash({
        type: 'correct',
        message: 'Document sent for signature successfully',
      })
      onClose()
    } catch (error) {
      app.setFlash({
        type: 'wrong',
        message: 'Error sending document for signature',
      })
    }
  }

  return (
    <Modal
      title="Select Employee"
      onClose={onClose}
      style={{
        top: '-5%',
      }}
      illustration={'user'}
      description="Select an employee from the dropdown"
      disableFocusTrap
      shouldCloseOnOverlayClick={false}
      onSubmit={handleSubmit}
      footer={
        <Box gap="s8" flexDirection="row" alignItems="center" justifyContent="flexEnd">
          <F0Button
            variant="outline"
            onClick={onClose}
            disabled={loading}
            label={i18n.t('common.cancel')}
          />
          <F0Button
            submit
            loading={loading}
            disabled={!selectedEmployeeId}
            label="Send for Signature"
          />
        </Box>
      }
    >
      <Box gap="s32" maxWidth="s400">
        <Box gap="s16">
          <Box gap="s8">
            <EmployeeSelectorV2
              value={selectedEmployeeId}
              onChange={setSelectedEmployeeId}
              forcedFilters={{ includeInactive: false }}
              label="Employee"
            />
          </Box>

          {selectedEmployeeId && (
            <Box gap="s8">
              <Text.Normal size="200" color="grey600">
                Selected employee ID: {selectedEmployeeId}
              </Text.Normal>
            </Box>
          )}
        </Box>
      </Box>
    </Modal>
  )
}
